module.exports = __webpack_public_path__ + "static/media/heart.7880aa5a.svg";